import React, { useMemo } from 'react';
import { Grid, Typography, TextField } from '@mui/material';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

const RequirementDetails = ({ selectedOffer, allProductMaster, reqid = false}) => {
  const DATE_FORMAT = 'DD-MM-YYYY';

  // Move useMemo before any early return
  const productDetails = useMemo(() => {
    if (!selectedOffer || !allProductMaster) {
      return {
        productName: '',
        productGrade: '',
      };
    }
    const product = allProductMaster.find(
      (item) => item.ProductID === selectedOffer?.ProductID
    );
    return {
      productName: product ? product.ProductName : '',
      productGrade: product ? product.Grade : '',
    };
  }, [allProductMaster, selectedOffer?.ProductID]);

  // Early return after useMemo
  if (!selectedOffer || !selectedOffer.RequirementsID || !allProductMaster) {
    return null;
  }

  const getPackagingValue = (packaging) => {
    if (!packaging) return '';
    if (packaging.includes('item=')) {
      const match = packaging.match(/item=([^,}]+)/);
      return match ? match[1].trim() : packaging;
    }
    return packaging;
  };

  const getDestination = () => {
    return selectedOffer.DeliveryLocation && typeof selectedOffer.DeliveryLocation === 'string'
      ? selectedOffer.DeliveryLocation.split('~')[0] || ''
      : '';
  };

  const getDeliveryPort = () => {
    return selectedOffer.DeliveryLocation && typeof selectedOffer.DeliveryLocation === 'string'
      ? selectedOffer.DeliveryLocation.split('~')[1] || ''
      : '';
  };

  const textFieldStyles = {
    backgroundColor: '#f5f5f5',
    width: '100%',
  };

  const containerStyles = {
    marginTop: '20px',
  };

  return (
    <div className="requirement-detail" style={containerStyles}>
      {/* <div className="header-text-re">
        {!reqid && (<div className="head-text">
          Requirement - {selectedOffer?.RequirementNumber || ''}
        </div>)}
        
      </div> */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="product-label">Product</Typography>
          <TextField
            value={productDetails.productName}
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="product-label"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="grade-label">Grade</Typography>
          <TextField
            value={productDetails.productGrade}
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="grade-label"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="origin-label">Origin</Typography>
          <TextField
            value={selectedOffer.OriginCountry || ''}
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="origin-label"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="destination-label">Destination</Typography>
          <TextField
            value={getDestination()}
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="destination-label"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="quantity-label">Quantity (MT)</Typography>
          <TextField
            value={selectedOffer.Quantity || ''}
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="quantity-label"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="incoterm-label">Inco Terms</Typography>
          <TextField
            value={selectedOffer.Incoterm || ''}
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="incoterm-label"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="payment-terms-label">Payment Terms</Typography>
          <TextField
            value={selectedOffer.PaymentTerms || ''}
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="payment-terms-label"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="packaging-label">Packaging</Typography>
          <TextField
            value={getPackagingValue(selectedOffer.ProductPackaging)}
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="packaging-label"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="delivery-port-label">Delivery Port</Typography>
          <TextField
            value={getDeliveryPort()}
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="delivery-port-label"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="delivery-start-label">Delivery (Start)</Typography>
          <TextField
            value={
              selectedOffer.DeliveryPeriodFrom
                ? dayjs(selectedOffer.DeliveryPeriodFrom).format(DATE_FORMAT)
                : ''
            }
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="delivery-start-label"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="delivery-end-label">Delivery (End)</Typography>
          <TextField
            value={
              selectedOffer.DeliveryPeriodTill
                ? dayjs(selectedOffer.DeliveryPeriodTill).format(DATE_FORMAT)
                : ''
            }
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="delivery-end-label"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="body2" id="valid-until-label">Valid Until</Typography>
          <TextField
            value={
              selectedOffer.ValidUntil
                ? dayjs(selectedOffer.ValidUntil).format(DATE_FORMAT)
                : ''
            }
            InputProps={{ readOnly: true }}
            sx={textFieldStyles}
            size="small"
            aria-labelledby="valid-until-label"
          />
        </Grid>
      </Grid>
    </div>
  );
};

RequirementDetails.propTypes = {
  selectedOffer: PropTypes.shape({
    RequirementsID: PropTypes.string,
    RequirementNumber: PropTypes.string,
    ProductID: PropTypes.string,
    OriginCountry: PropTypes.string,
    DeliveryLocation: PropTypes.string,
    Quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Incoterm: PropTypes.string,
    PaymentTerms: PropTypes.string,
    ProductPackaging: PropTypes.string,
    DeliveryPeriodFrom: PropTypes.string,
    DeliveryPeriodTill: PropTypes.string,
    ValidUntil: PropTypes.string,
  }),
  allProductMaster: PropTypes.arrayOf(
    PropTypes.shape({
      ProductID: PropTypes.string,
      ProductName: PropTypes.string,
      Grade: PropTypes.string,
    })
  ),
};

export default RequirementDetails;